import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { selectStudent } from "../reduxSlices/studentSlice";
import { postSeleccionaCarrera } from "../Api/authentication";
import logo from "../assets/ditella-logo.png";
import { useAuth } from "../hooks/useAuth";
import { CarreraItem } from "../types";
import Translatable from "../components/Translatable/Translatable";

const SeleccionCarrera = () => {
  const student = useSelector(selectStudent);
  const location = useLocation();
  const {
    selectingCarrera,
    setSelectingCarrera,
    seleccionaCarrera,
    carrerasList: hookCarrerasList,
    setCarrerasList,
  } = useAuth();
  const [localCarrerasList, setLocalCarrerasList] = useState<CarreraItem[]>([]);
  const colorsCarreras = ["#C47DDD", "#2277DA", "#209DAE", "#97D86C", "#FBC54F", "#FF7A30", "#FF7A30"];

  useEffect(() => {
    if (location.state?.carreras) {
      setLocalCarrerasList(location.state.carreras);
      setCarrerasList(location.state.carreras);
    } else {
      const storedCarreras = sessionStorage.getItem("carrerasList");
      if (storedCarreras) {
        const parsedCarreras = JSON.parse(storedCarreras);
        setLocalCarrerasList(parsedCarreras);
        setCarrerasList(parsedCarreras);
      } else if (student.listadoCarreras?.length > 0) {
        setLocalCarrerasList(student.listadoCarreras);
      }
    }
  }, [location.state, student.listadoCarreras, setCarrerasList]);

  const handleSelectCarrera = (id: number, nombreCarrera: string) => {
    setSelectingCarrera(true);
    seleccionaCarrera(id, nombreCarrera, postSeleccionaCarrera);
  };

  const displayCarreras =
    location.state?.carreras || hookCarrerasList?.length > 0 ? hookCarrerasList : localCarrerasList;

  return (
    <div className="page flex flex-col items-center justify-center min-h-screen">
      <img src={logo} alt="logo Ditella" width={150} className="mb-8" />
      <div className="container-multi-carrera">
        <p className="text-center text-lg mb-6">
          <Translatable as="span">Elegí tu carrera para ver la oferta de cursos.</Translatable>
        </p>
        <div className="container-multi-carrera">
          {displayCarreras && displayCarreras.length > 0 ? (
            displayCarreras.map((c, i) => (
              <button
                key={c.idAlumnoPrograma}
                className="carrera-container-select"
                disabled={selectingCarrera}
                style={{ borderColor: colorsCarreras[i % colorsCarreras.length] }}
                onClick={() => handleSelectCarrera(c.idAlumnoPrograma, c.descripcionCarrera)}
              >
                <h3>
                  <Translatable as="span">{c.descripcionCarrera}</Translatable>
                </h3>
              </button>
            ))
          ) : (
            <p>
              <Translatable as="span">No se encontraron carreras disponibles. Por favor intentá nuevamente.</Translatable>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SeleccionCarrera;
